<template>
    <div>
        <NavBar style="max-height:50px;margin-bottom: 10px;" :username="currentUserName" :pageName="pageName" />
        <v-app>
            <div style="background-color: #f5faff; height: 96vh;">
                <v-row cols="12">
                    <v-col cols="2">
                        <SideBar style="max-height: 50px;" :pageName="pageName"></SideBar>
                    </v-col>
                    <v-col cols="10">
                        <div style="margin: 1%">
                            <v-tabs
                                v-model="selectedTabID"
                                bg-color="primary"
                                align-tabs="center"
                            >
                                <v-tab value="teleconsultation">TeleConsultation</v-tab>
                                <v-tab value="quickhelp">Quick Help</v-tab>
                            </v-tabs>
                        </div>
                        <div class="d-flex flex-column" style="width: 50%; justify-content: center; align-items: center; margin: 5%; border: 2px solid; padding: 5%;">
                            <v-text-field 
                                solo flat outlined
                                background-color="#F4F6FA"
                                v-model="referenceNumber"
                                placeholder="Appointment Reference Number"
                                label="Appointment Reference Number"
                                @input="filterNumbers"
                            />
                            <v-btn color="primary"
                                :disabled="!referenceNumber || referenceNumber.length < 4"
                                @click="makeTheAppointmentJoinable"
                            >
                                Make Joinable
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-app>
    </div>
</template>

<script>
import axios from 'axios';
import NavBar from "../../navbar.vue";
import SideBar from "../../../views/sideBar.vue";
export default {
    name: 'MakeJoinable',
    components: {
        NavBar, SideBar
    },
    data() {
        return {
            pageName: 'MakeJoinable',
            currentUser: '',
            currentUserName: '',
            selectedTabID: '',
            referenceNumber: null,
            referenceNumberEnetered: true,
        }
    },
    methods: {
        filterNumbers(value) {
            this.referenceNumber = value.replace(/\D/g, '');
            console.log(this.referenceNumber.length)
        },
        async makeTheAppointmentJoinable() {
            console.log('Entered into the Joinable');
            var getAccessData = {
                token : this.currentUser,
                referenceNumber: this.referenceNumber,
                appointmentType: this.selectedTabID == 0 ? 'TeleConsultation' : 'QuickHelp',
                typeOfUser : "ADMIN",
                adminType : "ADMIN"
            }
            try {
                let makeJoinableDetails = await axios.post(process.env.VUE_APP_BACKEND_URL + "/makeJoinable", getAccessData);
                console.log(makeJoinableDetails)
                if(makeJoinableDetails.status == 200) {
                    alert(`${this.referenceNumber} is joined`);
                    this.referenceNumber = null;
                } else {
                    alert('No Appointment');
                }
            } catch (makeJoinableDetailsError) {
                console.log('makeJoinableDetailsError Response:', makeJoinableDetailsError.response);
                if (makeJoinableDetailsError.response.status == 400) {
                    alert(`${this.referenceNumber} is not available or Booking Time Ended`);
                }
                console.log('makeJoinableDetailsError Status:', makeJoinableDetailsError.response.status);
            }
        }
    },
    async mounted() {
        this.currentUser = this.$cookies.get("token");
        if(!this.currentUser){
            this.$router.push({
                name: "AdminLogin",
            });
        } else {
            var getAccessData = {
                token : this.currentUser,
                typeOfUser : "ADMIN",
                adminType : "ADMIN"
            }
            try {
                let adminDetails = await axios.post(process.env.VUE_APP_BACKEND_URL + "/getAdmin", getAccessData);
                if(adminDetails.status == 200) {
                    this.currentUserName = adminDetails.data.data.admin_name;
                } else {
                    window.alert('Something Went Wrong')
                }
            } catch (AdminDetailsError) {
                console.log('AdminDetailsError:', AdminDetailsError.response);
                if (getAdminError.response.status == 401) {
                    window.alert("Sorry !! You are unauthorized !!");
                    this.$router.push({
                        name: "AdminLogin",
                    });
                } else {
                    window.alert("Something went wrong...");
                }
            }
        }
    },
}
</script>
